import { Component, EventEmitter, Input, Output } from '@angular/core';
import moment from 'moment-timezone';
import { CrListVueJourComponent } from '../cr-list-vue-jour/cr-list-vue-jour.component';
import { DatePipe, NgIf } from '@angular/common';
import { CrOfDayPipe } from '../../common/pipes/cr-of-day/cr-of-day.pipe';
import { CrTempsRealisePipe } from '../../common/pipes/cr-temps-realise/cr-temps-realise.pipe';
import { DurationPipe } from '../../common/pipes/duration/duration.pipe';
import { ChronoInput } from '../../../shared/models/chrono.model';
import { CrActiviteInterne } from '../../../shared/models/activite-interne/activite-interne.model';
import { CrView } from '../../../shared/models/v2/cr.model';
import { PostCrRequest, PostCrResponse } from '../../../shared/models/v2/post-cr.model';

@Component({
  selector: 'cr-list-vue-semaine',
  templateUrl: 'cr-list-vue-semaine.component.html',
  standalone: true,
  styleUrls: ['./cr-list-vue-semaine.component.scss'],
  imports: [CrListVueJourComponent, DatePipe, CrOfDayPipe, CrTempsRealisePipe, DurationPipe, NgIf],
})
export class CrListVueSemaineComponent {
  /**
   * Booléen vérifiant si le mode suppression des brouillons est actif
   */
  @Input() isDraftCrDeletionModeActive: boolean;

  /**
   * Liste des CR filtrés
   */
  @Input() crListUserFiltered: (CrView | ChronoInput | CrActiviteInterne | PostCrResponse)[];

  /**
   * Liste des CR en cours d'envoi (utilisé pour le mode offline)
   */
  @Input() crEnCoursDenvoiFiltered: PostCrRequest[];

  @Input() set startOfWeek(value: string) {
    this.daysOfWeek = [];
    for (let i = 0; i < 7; i++) {
      this.daysOfWeek.push(moment(value).add(i, 'day').tz('Europe/Paris').toISOString());
    }
    this.daysOfWeek.reverse();
  }

  @Output() crEmitter = new EventEmitter<PostCrResponse | CrView | PostCrRequest | ChronoInput>();

  @Output() crActiviteInterneEmitter = new EventEmitter<CrActiviteInterne>();

  daysOfWeek: string[] = [];

  constructor() {}

  /**
   * Emet le CR vers le composant parent afin d'ouvrir le détail du CR
   */
  goToCrDetails(cr: PostCrResponse | CrView | PostCrRequest | ChronoInput) {
    this.crEmitter.emit(cr);
  }

  /**
   * Emet le CR de l'activité interne vers le composant parent afin d'ouvrir le détail du CR
   */
  goToCrActiviteInterneDetails(crActiviteInterne: CrActiviteInterne) {
    this.crActiviteInterneEmitter.emit(crActiviteInterne);
  }
}
